module.exports = __webpack_public_path__ + "img/4d78964.png";